import DOMPurify from 'dompurify';

export class ObjectTextSanitizer {
  static deepSanitize(data: any): any {
    if (typeof data === 'string') {
      return data.startsWith("data:image/*;base64,")
        ? data
        : DOMPurify.sanitize(data);
    }

    // ✅ Handle Date objects properly
    if (data instanceof Date) {
      return new Date(data.getTime());
    }

    // ✅ Handle File/Blob/FormData as-is (optional)
    if (data instanceof File || data instanceof Blob || data instanceof FormData) {
      return data;
    }

    if (Array.isArray(data)) {
      return data.map(item => this.deepSanitize(item));
    }

    if (typeof data === 'object' && data !== null) {
      const sanitizedObject: any = {};
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          sanitizedObject[key] = this.deepSanitize(data[key]);
        }
      }
      return sanitizedObject;
    }

    return data;
  }

  static sanitizeFormData(formData: FormData): FormData {
    const sanitized = new FormData();

    formData.forEach((value, key) => {
      sanitized.append(key, this.deepSanitize(value));
      // if (typeof value === 'string') {
      //   const sanitizedString = value.startsWith("data:image/*;base64,")
      //     ? value
      //     : DOMPurify.sanitize(value);
      //   sanitized.append(key, sanitizedString);
      // } else {
      //   sanitized.append(key, value);
      // }
    });

    return sanitized;
  }
}